var unsupportedBlock = {
    inline: false,
    group: 'block',
    atom: true,
    selectable: true,
    attrs: {
        originalValue: { default: {} },
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function (dom) { return ({
                originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}'),
            }); },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue),
        };
        return ['div', attrs, 'Unsupported content'];
    },
};

export { unsupportedBlock };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/unsupported-block.js